import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { RoleBasedRedirect } from '@/components/auth/RoleBasedRedirect';
import { UserProfileChecker } from '@/components/auth/UserProfileChecker';
import { AuthPage } from '@/pages/AuthPage';
import { SimpleDataEntryPage } from '@/pages/SimpleDataEntryPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { AdminDataViewPage } from '@/pages/AdminDataViewPage';
import { ReportsPage } from '@/pages/ReportsPage';
import { AdminPage } from '@/pages/AdminPage';
import { DiagnosticsPage } from '@/pages/DiagnosticsPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UserProfileChecker />
        <Routes>
          {/* Public Routes */}
          <Route path="/auth" element={<AuthPage />} />

          {/* Data Entry Routes - For Ward Nurses, IPC Nurses, etc. */}
          <Route
            path="/entry"
            element={
              <ProtectedRoute>
                <SimpleDataEntryPage />
              </ProtectedRoute>
            }
          />

          {/* Admin Routes - Admin Only */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute adminOnly>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/data"
            element={
              <ProtectedRoute adminOnly>
                <AdminDataViewPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/reports"
            element={
              <ProtectedRoute adminOnly>
                <ReportsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute adminOnly>
                <AdminPage />
              </ProtectedRoute>
            }
          />

          {/* Diagnostics Route - Protected, non-admin users can access */}
          <Route
            path="/diagnostics"
            element={
              <ProtectedRoute>
                <DiagnosticsPage />
              </ProtectedRoute>
            }
          />

          {/* Legacy routes - redirect to new structure */}
          <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/data-entry" element={<Navigate to="/entry" replace />} />
          <Route path="/reports" element={<Navigate to="/admin/reports" replace />} />
          <Route path="/admin" element={<Navigate to="/admin/settings" replace />} />
          <Route path="/alerts" element={<Navigate to="/admin/dashboard" replace />} />

          {/* Default redirect - role-based */}
          <Route path="/" element={<RoleBasedRedirect />} />
          <Route path="*" element={<RoleBasedRedirect />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
